<template>
    <div class="ending-wrap" v-if="$userData.ended">
        <v-layout class="ending" justify-center align-center>
            <img class="titleleaf" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/titleleaf_last.png" />
            <v-layout class="results">
                <img v-for="(i, index) in 2" class="ending-scene" :src="wealth(index)" />
                <img v-for="(i, index) in 2" class="ending-scene" :src="health(index)" />
                <img v-for="(i, index) in 2" class="ending-scene" :src="relationship(index)" />
                <img v-for="(i, index) in 2" class="ending-scene" :src="honor(index)" />
            </v-layout>
        </v-layout>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                st: null,
                scene: 0,
                isPlaying: false,
            }
        },
        computed: {
        },
        beforeDestroy() {
            this.$eventBus.$off('START_ENDING')
            this.$stopAll()

            if (this.st) {
                clearTimeout(this.st)
                this.st = null
            }
        },
        mounted() {
            this.$eventBus.$on('START_ENDING', immediate => {

                if (this.st || this.isPlaying) {
                    return
                }

                this.isPlaying = true

                this.st = setTimeout(_ => {
                    this.$stopAll()
                    this.$playAudio(23)
                    $('.ending-wrap').show()
                    $('.titleleaf').fadeIn(1000, _ => {
                        this.st = setTimeout(_ => {

                            $('.titleleaf').fadeOut(1000, _ => {

                                this.playEnding()
                            })
                        }, 3000)
                    })
                }, immediate ? 0 : 5000)
            })
        },
        methods: {
            wealth(index) {
                const gender = this.$userData.gender.toLowerCase()
                const factor1 = this.$userData.factor1

                return this.$resultData.factor1(gender, factor1, index)
            },
            health(index) {
                const gender = this.$userData.gender.toLowerCase()
                const factor2 = this.$userData.factor2

                return this.$resultData.factor2(gender, factor2, index)
            },
            relationship(index) {
                const gender = this.$userData.gender.toLowerCase()
                const factor3 = this.$userData.factor3

                return this.$resultData.factor3(gender, factor3, index, this.$userData.spouse, this.$userData.hasBaby)
            },
            honor(index) {
                const gender = this.$userData.gender.toLowerCase()
                const factor4 = this.$userData.factor4

                return this.$resultData.factor4(gender, factor4, index)
            },

            playEnding() {

                $('.results').show()

                $('.ending-scene').eq(this.scene).fadeIn(1000, _ => {
                    setTimeout(_ => {
                        $('.ending-scene').eq(this.scene).fadeOut(1000, _ => {
                            if (this.scene === 7) {
                                this.ended()
                                return
                            }
                            this.scene++
                            this.playEnding()
                        })
                    }, 2000)
                })
            },

            ended() {
                $('.ending-wrap').hide()
                this.$eventBus.$emit('ENDING_ENDED')
                this.isPlaying = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .ending-wrap {
        position: absolute;

        display: none;
        pointer-events: none;
    }
    .ending {
        top: 0; bottom: 0;
        left: 0; right: 0;
    }

    .titleleaf {
        width: 945px;
        height: 590px;
        overflow: hidden;
        display: none;
    }
    .results {
        width: 945px;
        height: 590px;
        overflow: hidden;
        position: relative;
        display: none;

        img {
            position: absolute;
            left: 0;
            top: 0;
            display: none;
        }
    }
</style>
